// ValidateCustomer ValidationType members the backend still accepts for saved recipes but that
// authors should not pick: INSURANCE (use INSURANCE_TYPE_CHECK) and PRESCRIPTION_STATUS (use
// PRESCRIPTION_FILL_STATUS).
const DEPRECATED_VALIDATION_TYPES = ['INSURANCE', 'PRESCRIPTION_STATUS'];

export const isDeprecatedValidationType = (vtype: string): boolean =>
  DEPRECATED_VALIDATION_TYPES.includes(vtype.toUpperCase());

// Pharmacy FillStatus values accepted by PRESCRIPTION_FILL_STATUS.
export const PRESCRIPTION_FILL_STATUS_VALUES = ['PENDING', 'PURCHASED', 'CANCELED', 'COMPLETE'];

// Prescription-level status values accepted by PRESCRIPTION_RX_STATUS.
export const PRESCRIPTION_RX_STATUS_VALUES = ['PRE_PV1', 'ACTIVE', 'DISCONTINUED'];

// CRISPS InsuranceState and PayerClassification values accepted by INSURANCE_TYPE_CHECK.
export const INSURANCE_STATE_VALUES = ['ACTIVE', 'INIT', 'INACTIVE', 'DELETED', 'VERIFIED', 'UNVERIFIED', 'INVALID STATE'];
export const INSURANCE_TYPE_VALUES = ['INSURANCE', 'GOVERNMENT', 'DISCOUNT', 'COUPON', 'CASH'];
